import { useState } from "react";
import { downloadFile } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function AnnualReportButton({ variant = "outline" }) {
  const thisYear = new Date().getFullYear();
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(String(thisYear));
  const [busy, setBusy] = useState(false);
  const years = Array.from({ length: 6 }, (_, i) => String(thisYear - i));

  const download = async () => {
    setBusy(true);
    try {
      await downloadFile("/reports/annual", `vuzurent-${year}-year-end-summary.pdf`, { year });
      toast.success(`${year} year-end summary downloaded`);
      setOpen(false);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant={variant} className="gap-2" onClick={() => setOpen(true)} data-testid="annual-report-btn">
        <FileSpreadsheet className="h-4 w-4" /> Year-end summary
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="annual-report-dialog">
          <DialogHeader><DialogTitle>Year-end tax summary</DialogTitle>
            <DialogDescription>One PDF across all houses: rent charged, Section 8 HAP and copay received, late fees, totals, outstanding balances and a month-by-month table per house.</DialogDescription></DialogHeader>
          <div className="space-y-1.5"><Label>Calendar year</Label>
            <Select value={year} onValueChange={setYear}>
              <SelectTrigger data-testid="annual-report-year"><SelectValue /></SelectTrigger>
              <SelectContent>{years.map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}</SelectContent>
            </Select></div>
          <DialogFooter><Button onClick={download} disabled={busy} className="w-full gap-2" data-testid="annual-report-download">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />} Download {year} PDF</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
